import React from "react";
import { NavigationMenu } from "@rsmus/rsm-catt-ui/dist/components/types/navigationBar.types";

export const navigationMenuButtonsDefaultValue = [] as NavigationMenu[];
export const userRoleValue = {} ;

export const SharedLayoutContext = React.createContext({
		navigationMenuButtons: navigationMenuButtonsDefaultValue,
		setNavigationMenuButtons: (_navigationMenuButtons: NavigationMenu[]) => {},
		setUserRole: (_userRole: any) => {},
		userRole: userRoleValue
	}
);

export default SharedLayoutContext;
